// extracted by mini-css-extract-plugin
module.exports = {"carrierWrapper":"ClientInsurance_carrierWrapper__2281u","title":"ClientInsurance_title__1mtR3","itemText":"ClientInsurance_itemText__2QVab"};